import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

(async () => {
  const response = await fetch('assets/configuration/appsettings.json');
  const appSettings = await response.json();
  if (environment.production) {
    enableProdMode();
  } else if (
    window.location.hostname === 'localhost' ||
    window.location.hostname === 'bs-local.com'
  ) {
    // bs-local.com is used for browserstack localhost testing
    // local settings
    const response = await fetch('assets/configuration/appsettings.local.json');
    if (response.ok) {
      const localSettings = await response.json();
      if (localSettings) {
        appSettings.applicationSettings = {
          ...appSettings.applicationSettings,
          ...localSettings.applicationSettings,
        };
      }
    } else {
      console.log(
        'No appsettings.local.json found. Using appsettings.json. See https://auto-graphics.atlassian.net/l/cp/PYSTf55X',
      );
    }
  }
  window['appSettings'] = appSettings;

  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
})();
